import React from "react";
import { IconBase, IconComponent } from "../../core/Icons";

/** Outline grid — matches other sidebar icons (white stroke + #8BC8FF accent). */
export const DashboardIcon: React.FC<IconComponent> = (props) => {
  return (
    <IconBase {...props}>
      <rect x="6" y="6" width="12" height="12" rx="2" stroke="white" strokeWidth="2" fill="none" />
      <rect x="20" y="6" width="12" height="12" rx="2" stroke="white" strokeWidth="2" fill="none" />
      <rect x="6" y="20" width="12" height="12" rx="2" stroke="white" strokeWidth="2" fill="none" />
      <rect x="20" y="20" width="12" height="12" rx="2" fill="#8BC8FF" />
    </IconBase>
  );
};
